/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_Contact_InfoInputs */

const en_resume_editor_contact_info = /** @type {(inputs: Resume_Editor_Contact_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Information`)
};

const de_resume_editor_contact_info = /** @type {(inputs: Resume_Editor_Contact_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktinformationen`)
};

const fr_resume_editor_contact_info = /** @type {(inputs: Resume_Editor_Contact_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coordonnees`)
};

const es_resume_editor_contact_info = /** @type {(inputs: Resume_Editor_Contact_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informacion de contacto`)
};

const it_resume_editor_contact_info = /** @type {(inputs: Resume_Editor_Contact_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni di contatto`)
};

const nl_resume_editor_contact_info = /** @type {(inputs: Resume_Editor_Contact_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contactgegevens`)
};

const pl_resume_editor_contact_info = /** @type {(inputs: Resume_Editor_Contact_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dane kontaktowe`)
};

const fi_resume_editor_contact_info = /** @type {(inputs: Resume_Editor_Contact_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yhteystiedot`)
};

const da_resume_editor_contact_info = /** @type {(inputs: Resume_Editor_Contact_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktoplysninger`)
};

const sv_resume_editor_contact_info = /** @type {(inputs: Resume_Editor_Contact_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktuppgifter`)
};

/**
* | output |
* | --- |
* | "Contact Information" |
*
* @param {Resume_Editor_Contact_InfoInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_contact_info = /** @type {((inputs?: Resume_Editor_Contact_InfoInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_Contact_InfoInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_contact_info(inputs)
	if (locale === "fr") return fr_resume_editor_contact_info(inputs)
	if (locale === "es") return es_resume_editor_contact_info(inputs)
	if (locale === "it") return it_resume_editor_contact_info(inputs)
	if (locale === "nl") return nl_resume_editor_contact_info(inputs)
	if (locale === "pl") return pl_resume_editor_contact_info(inputs)
	if (locale === "fi") return fi_resume_editor_contact_info(inputs)
	if (locale === "da") return da_resume_editor_contact_info(inputs)
	if (locale === "sv") return sv_resume_editor_contact_info(inputs)
	return en_resume_editor_contact_info(inputs)
});